import { IFramesConfig } from '../../state/app/iframes';
import apiClient from '../common/apiClient';

export const restGetModules = (): Promise<IFramesConfig> =>
    apiClient.getJsonConfiguration('iframe.json');
